import React from "react";
import "./NotFound.css";

export default () =>
  <div className="NotFound">
    <h3>¿Estás perdido? esta página no existe!</h3>
  </div>;
